<template>
  <div>
    <b-row class="pt-2 pb-1">
      <b-col cols="6">
        <BreadcrumbMenu/>
      </b-col>
      <b-col cols="6" class="pr-3 text-right">
        <button-filters
          @show-modal="$root.$emit('bv::show::modal', $event)"
          :filters-count="filtersCount"
          @clear-search-filters="clearSearchFilters"
        />
      </b-col>
    </b-row>

    <!-- Filters -->
    <filter-modal @action="buildFilters()" @clear="clearSearchFilters()">
      <template v-slot:main-filters>
        <filters
          :service-order-filter.sync="serviceOrderFilter"
          :service-order-options="serviceOrderOptions"
          :template-filter.sync="templateFilter"
          :template-options="templateOptions"
          :service-orders-status-options="serviceOrdersStatusOptions"
          :service-orders-status-filter.sync="serviceOrdersStatusFilter"
          :unit-options="unitOptions"
          :unit-filter.sync="unitFilter"
        />
      </template>
    </filter-modal>

    <b-card class="mx-2" no-body>
      <b-row class="m-2">
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label class="text-capitalize">{{ $t("table.show") }}</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
          />
          <label class="text-capitalize">{{ $t("table.entries") }}</label>
        </b-col>

        <!-- Search -->
        <b-col cols="12" md="6">
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              :placeholder="$t('table.search') + '...'"
            />
            <b-button variant="secondary" @click="openAddFormModal" v-if="$can('create', 'MaintenanceForm')">
              <span class="text-nowrap text-capitalize">
              Agregar formulario
              </span>
            </b-button>

            <b-button
              @click="exportExcel()"
              variant="success"
              class="text-capitalize ml-1"
              type="button"
              :disabled="buttonExport"
              v-b-tooltip.hover
              :title="$t('messages.export.title')"
            >
              <feather-icon icon="DownloadCloudIcon" size="15" />
            </b-button>
          </div>
        </b-col>

        <!-- Botón para agregar formulario (selecciona OS) -->
        <!--<b-col cols="12" class="mt-1 ">
          <b-button size="sm" variant="primary" @click="openAddFormModal">
            Agregar formulario
          </b-button>
        </b-col>-->
      </b-row>

      <b-table
        ref="refListTable"
        class="position-relative"
        :items="fetchList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :empty-text="$t('no_record_found')"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #head(actions)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(name)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head()="data">
          <span> {{ $tc(data.label) }}</span>
        </template>

        <template #cell(pending)="data">
          <span v-if="getStatusDate(data.item, 'pending')">
            {{ formatDateAssigned(getStatusDate(data.item, 'pending')) }}
          </span>
        </template>

        <template #cell(in_review)="data">
          <span v-if="getStatusDate(data.item, 'in_review')">
            {{ formatDateAssigned(getStatusDate(data.item, 'in_review')) }}
          </span>
        </template>

        <template #cell(in_progress)="data">
          <span v-if="getStatusDate(data.item, 'in_progress')">
            {{ formatDateAssigned(getStatusDate(data.item, 'in_progress')) }}
          </span>
        </template>

        <template #cell(finished)="data">
          <span v-if="getStatusDate(data.item, 'finished')">
            {{ formatDateAssigned(getStatusDate(data.item, 'finished')) }}
          </span>
        </template>

        <template #cell(canceled)="data">
          <span v-if="getStatusDate(data.item, 'canceled')">
            {{ formatDateAssigned(getStatusDate(data.item, 'canceled')) }}
          </span>
        </template>

        <template #cell(unit)="data">
          {{ formatUnit(null, null, data.item) }}
        </template>

        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <!--<b-dropdown-item
              @click="openViewDocument(data.item.id)"
              v-if="$can('viewDocument', 'MaintenanceForm')"
            >
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50 text-capitalize">
                {{ $t("actions.view_document") }}
              </span>
            </b-dropdown-item>-->

            <b-dropdown-item
              v-if="$can('update', 'MaintenanceForm')"
              :to="`/maintenance/forms/${data.item.id}`"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50 text-capitalize">
                {{ $t("actions.edit") }}
              </span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="$can('delete', 'MaintenanceForm')"
              @click="confirmDelete(data.item.id)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50 text-capitalize">
                {{ $t("actions.delete") }}
              </span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted text-capitalize">
              {{
                $t("table.showing", {
                  from: dataMeta.from,
                  to: dataMeta.to,
                  of: dataMeta.of,
                })
              }}
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <Pagination
              :totalList="totalList"
              :currentPage="currentPage"
              @updatePagination="update"
              :perPage="perPage"
            />
          </b-col>
        </b-row>
      </div>
    </b-card>

    <!-- Modal para seleccionar ORDEN DE SERVICIO -->
    <b-modal
      id="maintenance_service_order_modal"
      title="Seleccionar orden de servicio"
      @ok="onServiceOrderModalOk"
    >
      <div class="mb-1">
        <label class="text-capitalize">Orden de servicio</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          v-model="selectedServiceOrderId"
          :options="serviceOrderOptions"
          :reduce="o => o.value"
          class="w-100"
        />
      </div>
    </b-modal>


    <ShowMaintenanceFormModal
      :template-id="templateId"
      :service-order-id="serviceOrderId"
      @onSubmitFormBooklet="onSubmitFormBooklet"
      @onFormValidated="onFormValidated"
    />

    <!-- Modal para visualizar PDF -->
    <template>
      <div v-if="isView" class="modal-overlay">
        <div class="modal-content">
          <b-button @click="closeModal" class="close-button">X</b-button>
          <div v-if="isLoading" class="loading-container">
            <b-spinner variant="primary" :label="$t('messages.loading.title')"></b-spinner>
            <p class="mt-2">{{ $t("messages.loading.document") }}</p>
          </div>
          <iframe
            v-if="itemView"
            :src="itemView"
            width="100%"
            height="600px"
            @load="onPdfLoad"
            @error="onPdfError"
            style="border: none;"
            v-show="!isLoading"
          ></iframe>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormCheckbox,
  BFormInvalidFeedback,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import { ref, computed, getCurrentInstance, onMounted } from "@vue/composition-api";
import useList from "./useList";
import vSelect from "vue-select";
import Swal from "sweetalert2";
import axios from "@/libs/axios";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Pagination from "@/components/Pagination.vue";
import ShowMaintenanceFormModal from "@/components/ShowMaintenanceFormModal.vue"; // ajusta ruta si cambia
import Filters from "./Filters.vue";
import FilterModal from "@/components/Filters/FilterModal.vue";
import ButtonFilters from "@/components/Filters/ButtonFilters.vue";

export default {
  components: {
    BreadcrumbMenu,
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BFormCheckbox,
    BFormInvalidFeedback,
    BPagination,
    BSpinner,
    Pagination,
    vSelect,
    ToastificationContent,
    ShowMaintenanceFormModal,
    Filters,
    FilterModal,
    ButtonFilters,
  },
  setup() {
    // Composables
    const {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      formatDateAssigned,
      tenantOptions,
      tenantFilter,
      filtersCount,
      clearSearchFilters,
      buildFilters,
      templateOptions,
      templateFilter,
      serviceOrderFilter,
      serviceOrdersStatusOptions,
      serviceOrdersStatusFilter,
      unitOptions,
      unitFilter,
      formatUnit,
      action,
    } = useList();

    const vm = getCurrentInstance().proxy;
    const store = vm.$store;
    const toast = useToast();
    const buttonExport = ref(false);

    // Breadcrumb / filtros
    const itemFilter = ref();
    const nameNav = ref("breadcrumbs.manteinance.maintenance_forms");

    const addItemFilter = (data) => {
      itemFilter.value = data;
    };

    const addItemFilterSearch = (data) => {
      data.forEach((element) => {
        if (nameNav.value === element.text) {
          searchQuery.value = element.searchQuery;
        }
      });
    };


    const serviceOrderOptions = computed(() => {
      const items = store.getters["service_orders/getItems"] || [];
      return items.map((so) => ({
        value: so.id,
        label:
          so.reference_number ||
          so.name ||
          `OS #${so.id}`,
      }));
    });

    const selectedServiceOrderId = ref(null);
    const templateId = ref(null);
    const serviceOrderId = ref(null);

    // PDF Viewer state
    const isView = ref(false);
    const itemView = ref(null);
    const isLoading = ref(false);
    const pdfBlobUrl = ref(null);

    const loadServiceOrders = async () => {
      try {
        await store.dispatch("service_orders/getAll", {
          max: 1000,
        });
      } catch (error) {
        console.error("Error loading service orders", error);
        toast({
          component: ToastificationContent,
          props: {
            title: vm.$t("messages.errors.loading_service_orders"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    };

    onMounted(() => {
      loadServiceOrders();
    });

    const getServiceOrderById = (id) => {
      const items = store.getters["service_orders/getItems"] || [];
      return items.find((so) => so.id === id);
    };

    // Abre modal de selección de OS
    const openAddFormModal = () => {
      selectedServiceOrderId.value = null;
      vm.$root.$emit("bv::show::modal", "maintenance_service_order_modal");
    };

    const showBookletModal = (detail) => {
      // detail: { template_id, service_id, status_id? }
      console.log("showBookletModal detail:", detail);

      templateId.value = detail.template_id;
      serviceOrderId.value = detail.service_id;

      vm.$root.$emit("bv::show::modal", "maintenance_form_modal");
    };

    const onServiceOrderModalOk = (bvModalEvt) => {
      if (!selectedServiceOrderId.value) {
        bvModalEvt.preventDefault();
        toast({
          component: ToastificationContent,
          props: {
            title: "Selecciona una orden de servicio",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return;
      }

      const so = getServiceOrderById(selectedServiceOrderId.value);
      if (!so) {
        bvModalEvt.preventDefault();
        toast({
          component: ToastificationContent,
          props: {
            title: "No se encontró la orden de servicio seleccionada",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return;
      }

      // Aquí soportamos varios posibles campos:
      // - id_maintenance_template (clásico)
      // - maintenance_template_id
      // - template_id
      // - relación template.id (como en tu ejemplo)
      const templateFromSO =
        so.id_maintenance_template ||
        so.maintenance_template_id ||
        so.template_id ||
        (so.template && so.template.id);

      if (!templateFromSO) {
        bvModalEvt.preventDefault();
        toast({
          component: ToastificationContent,
          props: {
            title: "La orden de servicio no tiene template ligado",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return;
      }

      const detail = {
        template_id: templateFromSO,
        service_id: so.id,
        status_id: so.status_id, // opcional
      };

      showBookletModal(detail);
    };

    const confirmDelete = (id) => {
      Swal.fire({
        title: "¿Estás seguro de elimar el formulario?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axios.delete(`/v1/maintenance-forms/${id}`).then(() => {
            refetchData();
            toast({
              component: ToastificationContent,
              props: {
                title: "Formulario eliminado correctamente",
                icon: "CheckIcon",
                variant: "success",
              },
            });
          });
        }
      });
    };

    const update = (data) => {
      currentPage.value = data;
    };

    const onSubmitFormBooklet = () => {
      // Al enviar el form, cerramos modal y refrescamos lista
      vm.$root.$emit("bv::hide::modal", "maintenance_form_modal");
      refetchData();
    };

    const onFormValidated = () => {
      refetchData();
    };

    // PDF Viewer functions
    const openViewDocument = async (id) => {
      isLoading.value = true;
      isView.value = true;
      itemView.value = null;

      // Limpiar cualquier blob URL anterior
      if (pdfBlobUrl.value) {
        window.URL.revokeObjectURL(pdfBlobUrl.value);
        pdfBlobUrl.value = null;
      }

      try {
        const response = await axios.get(`/v1/maintenance-forms/download_document/${id}`, {
          responseType: "blob",
          headers: { Accept: "application/pdf" },
        });

        // response.data ya es un Blob cuando usamos responseType: "blob"
        if (response.data instanceof Blob) {
          // Crear URL del blob directamente
          const url = window.URL.createObjectURL(response.data);
          pdfBlobUrl.value = url;
          itemView.value = url;
        } else {
          throw new Error("La respuesta no es un blob válido");
        }
      } catch (error) {
        isLoading.value = false;
        isView.value = false;
        toast({
          component: ToastificationContent,
          props: {
            title: error.response?.data?.message || vm.$t("messages.errors.loading_document"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    };

    const onPdfLoad = () => {
      // Ocultar loading cuando el iframe termine de cargar
      isLoading.value = false;
    };

    const onPdfError = () => {
      isLoading.value = false;
      toast({
        component: ToastificationContent,
        props: {
          title: vm.$t("messages.errors.showing_document"),
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
    };

    const closeModal = () => {
      isView.value = false;
      isLoading.value = false;

      // Limpiar el blob URL para evitar cache
      if (pdfBlobUrl.value) {
        window.URL.revokeObjectURL(pdfBlobUrl.value);
        pdfBlobUrl.value = null;
      }
      itemView.value = null;
    };

    const getStatusDate = (item, status) => {
      const statuses = item?.service_order?.status;
      if (!Array.isArray(statuses)) return null;

      const found = statuses.find(s => s.status === status);
      return found?.created_at ?? null;
    }

    const exportExcel = () => {
      if (!templateFilter.value || templateFilter.value.length !== 1) {
        toast({
          component: ToastificationContent,
          props: {
            title: "Debes seleccionar solo un template para exportar en el filtro.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return;
      }
      action.value = "export";
      fetchList();
    };

    return {
      nameNav,
      itemFilter,
      addItemFilter,
      addItemFilterSearch,

      update,
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      formatDateAssigned,
      tenantOptions,
      tenantFilter,
      confirmDelete,
      filtersCount,
      clearSearchFilters,
      buildFilters,
      getStatusDate,
      exportExcel,
      buttonExport,

      // service orders / modales
      serviceOrderOptions,
      selectedServiceOrderId,
      templateId,
      serviceOrderId,
      openAddFormModal,
      onServiceOrderModalOk,
      showBookletModal,
      onSubmitFormBooklet,
      onFormValidated,
      templateOptions,
      templateFilter,
      serviceOrderFilter,
      serviceOrdersStatusOptions,
      serviceOrdersStatusFilter,
      unitOptions,
      unitFilter,
      formatUnit,

      // PDF Viewer
      isView,
      itemView,
      isLoading,
      openViewDocument,
      closeModal,
      onPdfLoad,
      onPdfError,
    };
  },
};
</script>


<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  width: 90%;
  max-width: 1000px;
  border-radius: 8px;
  position: relative;
  min-height: 600px;
  max-height: 90vh;
  overflow: auto;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  background-color: #ff4d4d;
  color: white;
  font-size: 18px;
  font-weight: bold;
  border: none;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease;
  z-index: 1001;
}

.close-button:hover {
  background-color: #ff1a1a;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 600px;
}
</style>
